export enum RateTypeEnum {
  InvoiceDate = 0,
  PaymentDate,
  Manual,
  Automatic,
}
